<template>
  <div>
    <h3>Resources</h3>
    <div>
        If you need any assistance with your resume or other information about the application process, please reach out to Career Services.
        <ul>
            <li><a target="_blank" href="https://eoss-forms.asu.edu/form/get-feedback-career-services">Resume Dropbox</a></li>
            <li><a target="_blank" href="https://eoss.asu.edu/cs/students/interviewing">Interview Stream</a> </li>
            <li><a target="_blank" href="https://eoss.asu.edu/cs/sdcl">Sun Devil CareerLink (set an appointment)</a></li>
            <li><a target="_blank" href="https://eoss.asu.edu/cs/students/webinars">Pre-Recorded Webinars</a></li>
            <li><a target="_blank" href="https://asuevents.asu.edu/event-search?eventSearch={%22tags%22%3A[{%22vocabulary%22%3A%22asu_event_topic%22%2C%22term%22%3A%22land_that_dream_job%22%2C%22text%22%3A%22Land%20that%20dream%20job%22}]%2C%22text%22%3A%22%22}">Career Events</a></li>
            <li><a target="_blank" href="https://drive.google.com/drive/u/0/folders/0B2sH6141Ksmea3NWVEVLa19oQkU">Career Worksheets – highlight informational interviewing</a></li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>
